module.exports = __webpack_public_path__ + "media/images/pages/icn_balloon_number_blue_03-0f17b65ba77afc9aeb293604c141b45d.svg";